// @flow
import * as React from 'react';

import { Button, Container, LogoContainer } from './styles';

import { FormattedMessage } from 'react-intl';
import HiveLogo from '~/assets/hive-logo/logo.svg';
import messages from './intl';

const refresh = () => (global.location = global.location);

export default () => (
    <Container>
        <LogoContainer>
            <img alt="Hive Logo" src={HiveLogo} />
        </LogoContainer>
        <p>
            <FormattedMessage {...messages.message} />
        </p>
        <p>
            <FormattedMessage {...messages.buttonLabel} />
        </p>
        <Button onClick={refresh}>
            <FormattedMessage {...messages.buttonText} />
        </Button>
    </Container>
);



// WEBPACK FOOTER //
// ./src/components/error-boundary/error.js